import { createAction, props } from '@ngrx/store';
import { Destination } from 'src/objects/destination';
import { MappedArea } from 'src/objects/mapped-area';

export const setMappedArea = createAction(
  '[Mapped Area] Set Mapped Area',
  props<{mappedArea: MappedArea | null}>(),
);

export const loadMappedArea = createAction(
  '[Mapped Area] Load Mapped Area',
  props<{id: number}>(),
);

export const loadMappedAreaSuccess = createAction(
  '[Mapped Area] Load Mapped Area Success',
  props<{mappedArea: MappedArea}>(),
);

export const loadMappedAreaFailure = createAction(
  '[Mapped Area] Load Mapped Area Failure',
  props<{error: Error}>(),
);

export const loadMappedAreas = createAction(
  '[Mapped Area] Load Mapped Areas',
  props<{destination: Destination}>(),
);

export const loadMappedAreasSuccess = createAction(
  '[Mapped Area] Load Mapped Areas Success',
  props<{mappedAreas: MappedArea[]}>(),
);

export const loadMappedAreasFailure = createAction(
  '[Mapped Area] Load Mapped Areas Failure',
  props<{error: Error}>(),
);
